export const controlPropsBase = ['disabled', 'required', 'readOnly'];
export const inputControlPropsBase = [...controlPropsBase, 'placeholder'];